export default __webpack_public_path__ + "static/depression-a3c283a91586880ad04966f93abcf1af.webp";